<div class="index-banner">
    <h1>{{block.data.text}}</h1>
    <p>{{block.data.bodyText}}</p>
    <img src="/assets/img/icons/page-down-arrow.svg" alt="">
</div>
